



//请求消费记录列表
export const ALERT_SHOW = 'ALERT_SHOW'

//处理消费记录列表
export const ALERT_HIDE = 'ALERT_HIDE'
